<template>
  <div class="wrapper" >
    <div class="layout" >
      <div class="md-layout-item">
        <md-button
            style="background: #ffa726 !important;"
            class="ms-success ms-block"
            @click="classicModal = true"
        ><md-icon>library_books</md-icon> Посмотреть цвет</md-button
        >
        <modal v-if="classicModal" @close="classicModalHide">
          <template slot="header">
            <h4 class="modal-title">Цвет: {{ color_info[1] }}</h4>

          </template>

          <template slot="body" >
            <div  class="color" :style="{'background-color': `${color_info[2]}` }"> </div>
          </template>

          <template slot="footer">
            <md-button
                class="md-danger md-simple"
                @click="classicModalHide"
            >Закрыть</md-button
            >
          </template>
        </modal>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "@/components";
export default {
  components: {
    Modal
  },
  data() {
    return {
      classicModal: false,
    };
  },
  props: ['color_info'],

  methods: {
    classicModalHide() {
      this.classicModal = false;
    }
  }
};
</script>

<style>
.color {
  width: 100%;
  height: 250px;
}
</style>